import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

import { CommitteeLeaseRow } from '../../interfaces/committee-session.interface'

/**
 * Lo que la pantalla de Comités comparte con sus vistas enrutadas.
 *
 * Las vistas cuelgan del `<router-outlet>` del cascarón —así el encabezado y las cuatro cifras
 * sobreviven al cambio de vista en vez de recrearse— y un componente enrutado no recibe `@Input` de
 * su padre. Este servicio es ese cable, igual que `CobranzaShellService` para Cobranza.
 *
 * `providedIn: 'root'` y no en el componente: un hijo de `<router-outlet>` se crea en el inyector del
 * outlet, y colgar el servicio del componente padre depende de un detalle de la jerarquía de
 * inyectores que no es evidente al leerlo.
 */
@Injectable({ providedIn: 'root' })
export class CommitteeShellService {
  private readonly refresh$$ = new Subject<void>()

  /**
   * Una vista acaba de escribir algo que cambia las cifras: se creó una sesión, se votó, se cerró, se
   * subió un acta. El cascarón lo escucha y vuelve a pedir el resumen; sin esto «Votos que faltan» se
   * quedaría en el número de antes de votar.
   */
  readonly refresh$ = this.refresh$$.asObservable()

  /**
   * Las filas que una tabla dejó SELECCIONADAS antes de abrir el modal de nueva sesión.
   *
   * El modal se enciende por la dirección (`?llevar=id,id`) y solo recibe ids: para pintar el folio y
   * el cliente en los chips sin volver a pedir cada arrendamiento, la tabla los deja aquí al navegar.
   * Si el modal se abre sin nada preparado (recarga de la pestaña, enlace desde el expediente), los
   * resuelve él mismo por id.
   */
  private staged: CommitteeLeaseRow[] = []

  refresh(): void {
    this.refresh$$.next()
  }

  stage(rows: CommitteeLeaseRow[]): void {
    this.staged = [...rows]
  }

  /** Devuelve lo preparado y lo vacía: cada apertura del modal parte de cero. */
  takeStaged(): CommitteeLeaseRow[] {
    const rows = this.staged
    this.staged = []

    return rows
  }
}
